import React, { FC } from 'react';
import { Modal, Button } from 'react-bootstrap';
import cx from 'classnames';
import style from './confirmation-modal.module.scss';

interface ConfirmationModalProps {
  show: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  dialogClassName?: string;
  contentClassName?: string;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  show,
  title = 'Potvrda akcije',
  message,
  confirmLabel = 'Potvrdi',
  cancelLabel = 'Otkaži',
  onConfirm,
  onCancel,
  dialogClassName,
  contentClassName
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      dialogClassName={cx(style.modalDialog, dialogClassName)}
      contentClassName={cx(style.modalContent, contentClassName)}
    >
      <Modal.Header closeButton className={style.modalHeader}>
        <Modal.Title className={style.modalTitle}>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className={style.modalBody}>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer className={style.modalFooter}>
        <Button
          variant="secondary"
          onClick={onCancel}
          className={style.cancelButton}
        >
          {cancelLabel}
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          className={style.confirmButton}
        >
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
